import { Rutas } from '@/constants/rutas';

export const NavigationCorporativoItems = [
    {
        title: 'Salón de la fama',
        shortTitle: 'Salón de la fama',
        path: Rutas.SALON_DE_LA_FAMA,
    },
    {
        title: 'Instala la app',
        shortTitle: 'Instala la app',
        path: Rutas.INSTALL_APP,
    },
    {
        title: 'Novedades',
        shortTitle: 'Novedades',
        path: Rutas.NOVEDADES,
    },
    {
        title: 'Colaboradores',
        shortTitle: 'Colaboradores',
        path: Rutas.COLABORADORES,
    },
    {
        title: 'Encuesta de satisfacción',
        shortTitle: 'Encuesta',
        path: Rutas.ENCUESTA_DE_SATISFACCION,
    },
    {
        title: 'Contáctanos',
        shortTitle: 'Contáctanos',
        path: Rutas.CONTACTANOS,
    },
    {
        title: 'Política de privacidad',
        shortTitle: 'Política',
        path: Rutas.POLITICAS_PRIVACIDAD,
    },
    {
        title: 'Términos y condiciones',
        shortTitle: 'Términos',
        path: Rutas.TERMINOS_CONDICIONES,
    },
    {
        title: 'Kit digital',
        shortTitle: 'Kit digital',
        path: Rutas.KIT_DIGITAL,
    },
    {
        title: 'Creadores de contenido',
        shortTitle: 'Creadores',
        path: Rutas.CREADORES_CONTENIDO,
    },
    {
        title: 'Sitios recomendados',
        shortTitle: 'Sitios',
        path: Rutas.SITIOS_RECOMENDADOS,
    },
];
